module.exports = __webpack_public_path__ + "img/patrulla_ministerial_up.4fb7199a.svg";